import { Pipe, PipeTransform } from '@angular/core';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { hasValue, isArray } from '@app/util';
import * as R from 'ramda';

const commaSeparated: any = R.join(', ');
const getDisplayProperty = R.head;

@Pipe({
  name: 'commaSeparated'
})
export class CommaSeparatedPipe implements PipeTransform {

  translate = item => this.translateService.translate(item);

  constructor(private translateService: PcsTranslateService) {}

  transform(value: any, ...args: any[]): any {
    if (!value || R.isEmpty(value)) {
      return '';
    }

    if (!isArray(value)) {
      throw new Error('The input value in CommaSeparatedPipe must be an Array');
    }

    const propToDisplay = hasValue(args) ? R.prop(getDisplayProperty(args)) : R.identity;
    const getDisplayName = R.compose(this.translate, propToDisplay);

    const getStringArray: any = R.ifElse(
      hasValue,
      R.map(getDisplayName),
      R.always(R.identity)
    );

    const stringArray = getStringArray(value);

    return commaSeparated(stringArray);
  }
}
